import { FileText } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCustomNotesPaper = mkIcon(FileText);